import React, { FC } from 'react';

import Brick from '../Brick';
import ContentArea from 'components/common/ContentArea';

import useStyles from './style';

const NotificationPlaceholder: FC = () => {
  const classes = useStyles();

  return (
    <ContentArea className={classes.notification} shadowed>
      <Brick className={classes.photo} animated={false} />
      <div className={classes.info}>
        <Brick className="title" animated={false} />
        <Brick className="desc" />
      </div>
      <Brick className={classes.status} animated={false} />
    </ContentArea>
  );
};

export default NotificationPlaceholder;
